// Flowise Chatbot Configuration
export const FLOWISE_CONFIG = {
  // Replace these with your actual Flowise configuration
  chatflowid:
    (window as any).env?.REACT_APP_FLOWISE_CHATFLOW_ID ||
    process.env.REACT_APP_FLOWISE_CHATFLOW_ID ||
    'your-chatflow-id-here',
  apiHost:
    (window as any).env?.REACT_APP_FLOWISE_API_HOST ||
    process.env.REACT_APP_FLOWISE_API_HOST ||
    'http://localhost:3000',

  theme: {
    button: {
      backgroundColor: '#F0514E', // Matches your Chakra UI theme
      right: 20,
      bottom: 20,
      size: 'medium' as const,
      dragAndDrop: true,
      iconColor: '#FFFFFF',
      autoWindowOpen: {
        autoOpen: false,
        openDelay: 2000,
        autoOpenOnMobile: false,
      },
    },
    chatWindow: {
      showTitle: true,
      title: 'Lixi NFT Support',
      titleAvatarSrc: '',
      showAgentMessages: true,
      welcomeMessage: 'Xin chào! Mình có thể giúp gì cho bạn về Lixi NFT?',
      errorMessage: 'Đã xảy ra lỗi, vui lòng thử lại',
      backgroundColor: '#F6F3F0',
      height: 500,
      width: 400,
      fontSize: 16,
      fontFamily: '"IBM Plex Mono", monospace',
      poweredByTextColor: '#303030',
      botMessage: {
        backgroundColor: '#FAF6D8',
        textColor: '#303030',
        showAvatar: true,
        avatarSrc: '/logo192.png', // Using your site's logo
        fontFamily: '"IBM Plex Mono", monospace',
      },
      userMessage: {
        backgroundColor: '#F0514E',
        textColor: '#ffffff',
        showAvatar: false,
        fontFamily: '"IBM Plex Mono", monospace',
      },
      textInput: {
        placeholder: 'Nhập tin nhắn...',
        backgroundColor: '#ffffff',
        textColor: '#303030',
        sendButtonColor: '#F0514E',
        maxChars: 1000,
        maxCharsWarningMessage:
          'Tin nhắn của bạn quá dài. Vui lòng rút ngắn tin nhắn.',
        autoFocus: false,
        sendMessageSound: true,
        receiveMessageSound: true,
        fontFamily: '"IBM Plex Mono", monospace',
      },
      feedback: {
        color: '#303030',
      },
      footer: {
        textColor: '#303030',
        text: 'Powered by',
        company: 'Cohost AI',
        companyLink: 'https://cohost.ai',
      },
    },
  },

  chatflowConfig: {
    // Additional chatflow configuration can be added here
  },
} as const;

// Environment variable validation
export const validateFlowiseConfig = () => {
  const warnings: string[] = [];

  const chatflowId =
    (window as any).env?.REACT_APP_FLOWISE_CHATFLOW_ID ||
    process.env.REACT_APP_FLOWISE_CHATFLOW_ID;
  const apiHost =
    (window as any).env?.REACT_APP_FLOWISE_API_HOST ||
    process.env.REACT_APP_FLOWISE_API_HOST;

  if (!chatflowId) {
    warnings.push(
      'REACT_APP_FLOWISE_CHATFLOW_ID environment variable is not set',
    );
  }

  if (!apiHost) {
    warnings.push('REACT_APP_FLOWISE_API_HOST environment variable is not set');
  }

  if (warnings.length > 0) {
    console.warn('Flowise Configuration Warnings:', warnings);
  }

  return warnings.length === 0;
};
